// Motifs d'absence des collaborateurs du planning — référentiel PARTAGÉ entre
// l'écran Configuration ▸ Absences et le popover de création rapide de la
// grille. Les `value` de conges/maladie/formation sont historiques et vivent
// en base : ne jamais les renommer sans migration.
// ⚠️ Libellés SANS emoji (2026-09-05, demande utilisateur). Depuis que le motif
// est l'entête du bloc d'absence sur la grille — et non plus une étiquette en
// tête de colonne —, il est lu dans un espace de quelques dizaines de pixels :
// un picto y mange la place du mot qu'il est censé illustrer.
export const MOTIFS_ABSENCE = [
  { value: 'conges', label: 'Congé' },
  { value: 'maladie', label: 'Arrêt maladie' },
  { value: 'rtt', label: 'RTT' },
  { value: 'non_qualifiee', label: 'Absence non qualifiée' },
  { value: 'formation', label: 'Formation' },
  { value: 'autre_tache', label: 'Autre tâche' },
  { value: 'autre', label: 'Autre' },
];
